import React, { createContext, useContext, useReducer } from "react";
//creamos el context
export const StateContext = createContext();
//cambia el estado de la variable global definida en el state
export const SessionProvider = ({ reducer, initialState, children }) => (
  <StateContext.Provider value={useReducer(reducer, initialState)}>
    {children}
  </StateContext.Provider>
);
//provider : define las variables que se van a almacenar de forma global incluido las variables iniciales
//consumer : accede al valor de la variable global en cualquier componente de react
//en useReducerValues estan el estado actual del sesionReducer y del openMessageReducer
export const useStateValue = () => useContext(StateContext);
